import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-branch-container" }
const _hoisted_2 = {
  key: 0,
  class: "form-card-title"
}
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.props.title)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($setup.props.title), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass($setup.getItemClass(item)),
        onClick: ($event: any) => ($setup.listItemClick(item))
      }, _toDisplayString(item.content), 11, _hoisted_3))
    }), 128))
  ]))
}